import React from 'react';

const AgreementTemplate = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '300px',
      fontSize: '24px',
      color: '#666'
    }}>
      No access
    </div>
  );
};

export default AgreementTemplate;
